/**
 * Creates a keyboard event handler for clickable elements that should respond to Enter and Space keys
 * @param {Function} onClick - The click handler function to call when Enter or Space is pressed
 * @returns {Function} A keyboard event handler function
 */
export const handleClickableKeyDown = (onClick) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    onClick(e);
  }
};

/**
 * Creates a keyboard event handler for navigable list items with arrow key support
 * @param {Function} onSelect - The selection handler function
 * @param {number} index - Current item index in the list
 * @param {number} totalItems - Total number of items in the list
 * @param {boolean} disabled - Whether the item is disabled
 * @returns {Function} A keyboard event handler function
 */
export const handleListItemKeyDown =
  (onSelect, index, totalItems, disabled = false) =>
  (e) => {
    if (disabled) return;

    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        onSelect();
        break;
      case 'ArrowDown':
        e.preventDefault();
        if (index < totalItems - 1) {
          const nextElement = e.currentTarget.nextElementSibling;
          nextElement?.focus();
        }
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (index > 0) {
          const prevElement = e.currentTarget.previousElementSibling;
          prevElement?.focus();
        }
        break;
      default:
        break;
    }
  };
